module.exports = __webpack_public_path__ + "static/media/cloud-download.b3600e88.svg";